import { combineReducers } from 'redux';
import applicationReducer from './application-reducer';
import packageReducer from './packages-reducer';
import selectReducer from './selectReducers';
import banners from './banner-reducer';
import section from './custom-section-reducer';
import forms from './forms-reducer';

const reducers = combineReducers({
  applicationState: applicationReducer,
  bannersState: banners,
  sectionState: section,
  packages: packageReducer,
  promociones: selectReducer,
  forms: forms,
});

export default reducers;
